import { BlotterItemAction } from 'models/blotters/BlotterItemAction';
import { IBlotterQuoteItemStatus } from 'models/IBlotterItem';
import { QuoteAction } from 'state/common-form/infos/infos.model';
import {
  getBatchSelectedQuotes,
  getBlottersQuoteActions,
  getDynamicActiveTabActions,
  getStaticActiveTabActions,
} from 'state/scheduledRuns/selectors';
import { AppState } from 'state/state.model';
import { QuoteWorkspaceType } from 'state/workspaces/model';

function isBlotterItemActions(
  actions: ReadonlyArray<QuoteAction> | ReadonlyArray<BlotterItemAction>,
): actions is ReadonlyArray<BlotterItemAction> {
  const [firstAction] = actions;
  return (firstAction as BlotterItemAction)?.type !== undefined;
}

export function hasScheduledRunAction(actions: ReadonlyArray<QuoteAction> | ReadonlyArray<BlotterItemAction>): boolean {
  return isBlotterItemActions(actions)
    ? actions.some(action => action.type === 'ScheduleRun')
    : actions.some(action => action.name === 'ScheduleRun');
}

export function isScheduledRunOnStaticOrDynamicEnabled(
  workspaceType: Extract<QuoteWorkspaceType, 'static' | 'dynamic'>,
  state: AppState,
): boolean {
  switch (workspaceType) {
    case 'static': {
      const staticActiveTabActions = getStaticActiveTabActions(state);
      return hasScheduledRunAction(staticActiveTabActions);
    }
    case 'dynamic': {
      const dynamicActiveTabActions = getDynamicActiveTabActions(state);
      return hasScheduledRunAction(dynamicActiveTabActions);
    }
  }
}

export function isScheduledRunOnBatchEnabled(state: AppState): boolean {
  const selectedQuotes = getBatchSelectedQuotes(state);
  return selectedQuotes.every(({ actions }) => hasScheduledRunAction(actions));
}

export function isScheduledRunOnBlotterEnabled(state: AppState, quoteStatus?: IBlotterQuoteItemStatus): boolean {
  if (quoteStatus === 'Rejected' || quoteStatus === 'Failed') {
    return false;
  }
  const blottersQuoteActions = getBlottersQuoteActions(state);
  return hasScheduledRunAction(blottersQuoteActions);
}
